/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */


import { Component, OnInit, } from '@angular/core';

import { trigger, state, style, transition, animate } from '@angular/animations';

import { GlobalMessageService, GlobalMessage } from '../../services/global-message.service';

@Component({
  selector: 'global-message',
  templateUrl: './global-message.component.html',
  animations: [
    trigger('fadeInOut', [
      state('on', style({
        opacity: '1',
        'z-index': 10000
      })),
      state('off', style({
        opacity: '0',
        'z-index': -1
      })),
      transition('on => off', animate('500ms ease')),
      transition('off => on', animate('750ms ease-in-out'))
    ])
  ]
})
export class GlobalMessageComponent implements OnInit {

	message: GlobalMessage = new GlobalMessage('', new Date());

	display: string = 'off';
  constructor(globalMessageService: GlobalMessageService) {
  	globalMessageService.messageAdded$.subscribe(message => this.onMessage(message));
  }

  ngOnInit() {
  	this.display = 'off';
  }

  private onMessage(message: GlobalMessage): void {
  	this.message = message;
  	this.display = 'on';
  	setTimeout(() => {
  		this.display = 'off';
  	}, 4500);

  }

}



// WEBPACK FOOTER //
// ./client/app/global/global-message/global-message.component.ts